<template>
  <div>
    <DxDataGrid
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="false"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      :no-data-text="$t('noDataSelectedMaterialRequest')"
      class="custom-grid custom-grid-material-cart"
      :editing="{ mode: 'cell', allowUpdating: true }"
    >
      <DxScrolling mode="standard" />

      <DxPaging :page-size="5" />

      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel
        :visible="false"
        :width="300"
        :placeholder="$t('searchRequestCode')"
      />
      <DxColumn
        data-field="Cantidad"
        :caption="$t('quantity')"
        :editor-options="{ min: 1, showSpinButtons: true }"
        :allow-sorting="true"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
        :width="90"
      >
      </DxColumn>
      <DxColumn
        data-field="CodArticulo"
        :caption="$t('article')"
        :allow-sorting="true"
        :allow-editing="false"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="Descripcion"
        :caption="$t('description')"
        :allow-sorting="true"
        :allow-editing="false"
        :fixed="true"
        fixed-position="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        :buttons="editButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
        width="80"
      />
    </DxDataGrid>
    <div class="deleteBottom">
      <DeleteSelectedMaterials />
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';
import { mapActions } from 'vuex';
import DeleteSelectedMaterials from '@/components/UtilityComponents/DeleteSelectedMaterials/index.vue';
import iconTrash from '@/static/icons/ic_trash_new.svg';

export default {
  name: 'MaterialCart',
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxPager,
    DxPaging,
    DxScrolling,
    DeleteSelectedMaterials,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editButtons: [
        {
          icon: iconTrash,
          cssClass: 'grid-button-icon',
          onClick: this.deleteMaterial,
        },
      ],
    };
  },
  computed: {},
  methods: {
    init(e) {
      this.grid = e;
    },
    deleteMaterial(e) {
      this.deleteMaterialsSelected(e.row.data.CodArticulo);
    },
    ...mapActions('materialRequest', ['deleteMaterialsSelected']),
  },
};
</script>

<style>
.custom-grid-material-cart
  .dx-gridbase-container
  > .dx-datagrid-rowsview {
  background: var(--Secondary-Green-10, #fff);
}
.custom-grid-material-cart .dx-datagrid-rowsview .dx-row {
  background: var(--Basic-White, #f2f8e2);
}
.custom-grid-material-cart .dx-datagrid-pager {
  border-top: none !important;
  background: var(--Secondary-Green-10, #fff) !important;
}
.custom-grid-user-management .dx-datagrid-headers {
  background: var(--Secondary-Green-10, #f2f8e2) !important;
}

.custom-grid-material-cart .dx-datagrid-rowsview .dx-editor-cell {
  overflow: visible !important;
  padding: 0 4px !important;
}
.custom-grid-material-cart .dx-texteditor-container {
  min-width: 80px !important;
  width: 100% !important;
  overflow: visible !important;
}

.custom-grid-material-cart .dx-texteditor-input-container {
  min-width: 0 !important;
  flex: 1 1 auto !important;
  overflow: visible !important;
}

.custom-grid-material-cart .dx-texteditor-input {
  min-width: 40px !important;
  width: 100% !important;
  text-align: right;
}

.custom-grid-material-cart .dx-texteditor-buttons-container {
  flex-shrink: 0 !important;
}

.custom-grid-material-cart .dx-numberbox-spin-container {
  flex-shrink: 0 !important;
}
</style>
